export const CROP_FIELD_TYPES = [
  {
    id: 1,
    name: "Productivo"
  },
  {
    id: 2,
    name: "Eriazo"
  },
  {
    id: 3,
    name: "Bosque"
  }
];

export default {
  computed: {
    cropFieldTypes() {
      return CROP_FIELD_TYPES;
    }
  },
  methods: {
    cropFieldTypeName(crop_field_type_id) {
      return this.cropFieldTypes.find(cf => cf.id == crop_field_type_id)?.name;
    }
  }
};
